import {
  GET_PHRASE,
  SHOW_PHRASE,
  CREATE_PHRASE,
  EDIT_PHRASE,
  DELETE_PHRASE
} from "@/store/modules/mutation-types";

export default {
  state: {},
  getters: {},
  actions: {
    async [GET_PHRASE]({ dispatch }, params) {
      const res = await dispatch("apiGet", {
        url: "/kanri/phrases",
        data: params.data
      });
      if (res.status !== 200 && res.status !== 204) {
        throw {
          status: res.status
        };
      }
      return res.data;
    },
    async [SHOW_PHRASE]({ dispatch }, params) {
      let url = "/kanri/phrases/" + params.id;
      const res = await dispatch("apiGet", {
        url: url,
        data: params.data
      });
      if (res.status !== 200 && res.status !== 204) {
        throw {
          status: res.status
        };
      }
      return res.data;
    },
    async [CREATE_PHRASE]({ dispatch }, params) {
      const res = await dispatch("apiPost", {
        url: "/kanri/phrases",
        data: params.data
      });
      if (res.status !== 200 && res.status !== 204) {
        throw {
          status: res.status
        };
      }
      return res.data;
    },
    async [EDIT_PHRASE]({ dispatch }, params) {
      let url = "/kanri/phrases/" + params.id;
      const res = await dispatch("apiPatch", {
        url: url,
        data: params.data
      });
      if (res.status !== 200 && res.status !== 204) {
        throw {
          status: res.status
        };
      }
      return res.data;
    },
    async [DELETE_PHRASE]({ dispatch }, params) {
      let url = "/kanri/phrases/" + params.id;
      const res = await dispatch("apiDelete", {
        url: url,
        data: params.data
      });
      if (res.status !== 200 && res.status !== 204) {
        throw {
          status: res.status
        };
      }
      return res.data;
    }
  },
  mutations: {}
};
